import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { ProductPriceViewQuery } from '~/graphql/types'

@Module({
  name: 'promotional-offers',
  stateFactory: true,
  namespaced: true,
})
export default class PromotionalOffers extends VuexModule {
  loading = true
  _items: ProductPriceViewQuery['product_price_view'] = []

  get items() {
    return this._items
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this._items = items
  }
}
